import styled from 'styled-components'
import { Card, CardBody, Heading, ArrowBackIcon, IconButton } from 'uikit'
import { useTranslation } from 'react-i18next'

interface NotificationProps {
  title: string
}

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
`

const CardWrapper = styled.div`
  width: 320px;
`

const BackButtonStyle = styled(IconButton)`
  position: relative;
  top: 120px;
  width: 40%;
`

const BackButton = () => {
  const { t } = useTranslation()

  return (
    <BackButtonStyle variant="primary" width="100%">
      <ArrowBackIcon color="white" mr="8px" />
      {t('PREDICTION_73')}
    </BackButtonStyle>
  )
}
// todo test
const Notification: React.FC<React.PropsWithChildren<NotificationProps>> = ({ title, children }) => {
  return (
    <Wrapper>
      <CardWrapper>
        <BackButton />
        <Card>
          <CardBody>
            <Heading mb="24px">{title}</Heading>
            {children}
          </CardBody>
        </Card>
      </CardWrapper>
    </Wrapper>
  )
}

export default Notification
